<template>
  <a
    title=""
    data-test="clear-workforce"
    @click="showClearWorkforceDialog = true">
    Clear workforce
  </a>
  <ConfirmationDialog
    v-model="showClearWorkforceDialog"
    data-test="confirmation-dialog-clear-workforce"
    :is-loading="clearWorkforceMutation?.fetching?.value"
    @confirmation-selection="
      (confirm) => (confirm ? clearWorkforce() : (showClearWorkforceDialog = false))
    ">
    <template #text-body>
      This action will clear all of the workforce for the
      {{ currSchedDataIdsStore.currTeamId }} team for the
      {{ currSchedDataIdsStore.currSchedPeriodId }} schedule period.
    </template>
  </ConfirmationDialog>
</template>

<script setup lang="ts">
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import { ClearWorkforceForTeamPeriodDocument } from "owfsa-graphql";
import { useCurrSchedDataIdsStore } from "@/stores/currSchedDataIds.store";
import { useMutation } from "@urql/vue";
import { ref } from "vue";
import { toast } from "vue-sonner";

const currSchedDataIdsStore = useCurrSchedDataIdsStore();
const clearWorkforceMutation = useMutation(ClearWorkforceForTeamPeriodDocument);

const showClearWorkforceDialog = ref(false);

async function clearWorkforce() {
  await clearWorkforceMutation.executeMutation({
    teamId: currSchedDataIdsStore.currTeamId,
    schedPeriodId: currSchedDataIdsStore.currSchedPeriodId,
  }).then(async (result) => {
    if (!result.error && !!result.data) {
      toast.success("Workforce settings have been cleared successfully");
      showClearWorkforceDialog.value = false;
    } else {
      toast.error("Error has occurred while clearing workforce settings");
    }
  });
}

</script>
